import api from "../utils/api";
import { LOGOUT } from "./types";
import { save as saveSetting } from "./settings";
import { pack } from "./alert";

export const get = () => async (dispatch) => {
    try {
        const res = await api.get(`/email/configurations`);
        return res.data;
    } catch (err) {
        return [];
    }
}

export const system = () => async (dispatch) => {
    try {
        const res = await api.get(`/email/configurations/system`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const save = ({uuid, name, system, host, port, secure, user, password}) => async (dispatch) => {
    try {
        const res = await api.post(`/email/configurations`, { uuid, name, host, port, secure, user, password });
        if (system) {
            await dispatch(saveSetting({ name: "FERA_EMAIL_CONFIGURATION", value: name }));
        }
        dispatch(pack(["email configuration saved"], "success"));
        return res.data;
    } catch (err) {
        dispatch(pack([`error on save. ${err}`], "error"));
    }
}

export const destroy = (uuid) => async (dispatch) => {
    try {
        const res = await api.delete(`/email/configurations/${uuid}`);
        dispatch(pack(["email configuration deleted"], "success"));
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}